import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { device } from 'styles/device';
import { space } from 'shared';

export const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.primary};
  background-color: ${({ theme }) => theme.white};
  border-radius: ${({ theme }) => theme.radiusMd || theme.borderRadiusDefault};
  color: ${({ theme }) => theme.primary};
  height: ${({ isActive, height }) => (isActive ? height : '38px')};
  overflow: hidden;
  transition: all 0.5s;
  margin-top: ${space(2)};
  cursor: pointer;
  @media ${device.mobile} {
    ${({ isActive }) => isActive
    ? ''
    : css`
            border: none;
          `};
  }
`;

export const Greetings = styled.span`
  @media ${device.mobile} {
    display: none;
  }
`;

export const RoleBadge = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: ${({ theme }) => theme.fontWeightSemiBold};
  line-height: 1;
  padding: ${space(4, 11)};
  margin-left: ${space(10)};
  border-radius: ${({ theme }) => theme.radiusPill};
  color: ${({ theme, colorKey }) => theme[colorKey]};
  background-color: ${({ theme, bgKey }) => theme[bgKey]};
  white-space: nowrap;
  @media ${device.mobile} {
    display: none;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: ${space(6, 10, 6, 25)};
  @media ${device.mobile} {
    padding: ${space(6)};
  }
`;

const avatarStyles = css`
  width: 25px;
  height: 25px;
  border-radius: ${({ theme }) => theme.borderRadiusRound};
  margin-left: ${space(15)};
  @media ${device.mobile} {
    margin-left: auto;
  }
`;

export const Avatar = styled.img`
  ${avatarStyles}
`;

export const DefaultAvatar = styled(FontAwesomeIcon)`
  ${avatarStyles};
  color: ${({ theme }) => theme.textColor};
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${space(15)};
  ${({ isActive }) => isActive
    ? ''
    : css`
          display: none;
        `};
`;

export const ActionItem = styled.div`
  padding: ${space(6, 12)};
  transition: all 0.5s;
  text-align: right;
  color: ${({ theme }) => theme.textColor};
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${({ theme }) => theme.grayE6};
  }
  &.disabled {
    opacity: 0.5;
    cursor: initial;
    &:hover {
      background-color: initial;
    }
  }
  .coming-soon {
    color: ${({ theme }) => theme.secondaryLight};
    font-size: 12px;
    padding-right: ${space(5)};
  }
`;
